import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useSpring, config } from 'react-spring';
import lottie from 'lottie-web';
import confirmLottie from '../../assets/confirm.json';
import gameOnLottie from '../../assets/gameOn.json';

import {
  Bar,
  ProgressBarContainer,
  BarFill,
  TextContainer,
  Text,
  Dot,
  DotsContainer,
  AnimsContainer,
  Anim,
} from './ProgressBar.styles';

import BarDot from '../../assets/progressBarDot.svg';

const ProgressBar = ({ currentStep }) => {
  const fillStyle = useSpring({
    width: currentStep === 2 ? "50%" : currentStep === 3 ? "100%" : "0%",
    from: { width: currentStep === 3 ? "50%" : "0%" },
    config: config.slow
  });

  const confirmLottieRef = useRef(null);
  const gameOnLottieRef = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: confirmLottieRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: confirmLottie,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet',
      },
    });

    lottie.loadAnimation({
      container: gameOnLottieRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: gameOnLottie,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet',
      },
    });
  }, []);

  const refs = [
    null,
    confirmLottieRef,
    gameOnLottieRef
  ];

  const steps= [
    'Sign up',
    'Confirm',
    'Game on!'
  ];

  return (
    <ProgressBarContainer currentStep={currentStep}>
      <Bar />
      <BarFill style={fillStyle} />
      <DotsContainer>
        {
          steps.map((step, i) => (
            <Dot key={step} src={BarDot} current={(currentStep >= i+1).toString()} />
          ))
        }
      </DotsContainer>
      <AnimsContainer>
        {
          steps.map((step, i) => (
            <Anim key={step} current={(currentStep === i+1).toString()} ref={refs[i]} />
          ))
        }
      </AnimsContainer>
      <TextContainer>
        {
          steps.map((step, i) => (
            <Text key={i} current={(currentStep === i+1).toString()}> {step} </Text>
          ))
        }
      </TextContainer>
    </ProgressBarContainer>
  );
};

ProgressBar.propTypes = {
  currentStep: PropTypes.number,
};

export default ProgressBar;